@if(showActionNotification){

  <!-- Google-style notification panel -->
  <div class="notif-panel">

    <!-- Header -->
    <div class="notif-header">
      <h3>Notificações</h3>
      <div class="notif-header-actions">
        <button class="notif-icon-btn" (click)="clickMarkAllAsRead()" matTooltip="Marcar todas como lidas" aria-label="Marcar todas como lidas">
          <span class="material-symbols-outlined">done_all</span>
        </button>
        <button class="notif-icon-btn" (click)="clickContainerOut()" aria-label="Fechar">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>

    <hr class="notif-divider" />

    <!-- Notification list -->
    <div class="notif-list">
      @if (listNotificacoes.length > 0) {
        @for (notificacao of listNotificacoes; track notificacao.idNotificacao) {
          <div class="notif-item" [ngClass]="{'unread': !notificacao.lido}" (click)="clickNotificacao(notificacao)">
            <div class="notif-icon">
              <span class="material-symbols-outlined">notifications</span>
            </div>
            <div class="notif-content">
              <span class="notif-title">{{ notificacao.titulo }}</span>
              <p class="notif-message">{{ notificacao.mensagem }}</p>
              <span class="notif-date">{{ notificacao.dataInclusao | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        }
      } @else {
        <div class="notif-empty">
          <span class="material-symbols-outlined">notifications_off</span>
          <span class="notif-empty-text">Nenhuma notificação encontrada.</span>
        </div>
      }
    </div>

  </div>

  <div class="container-out" (click)="clickContainerOut()"></div>
}